export { default as StrategyCenterSubHeader } from './StrategyCenterSubHeader';
